export default __webpack_public_path__ + "images/ne-6fd3ccdef1a91e8be5aef3841765069d.svg";